/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Constraint } from './Constraint';
import {
    ConstraintFromJSON,
    ConstraintFromJSONTyped,
    ConstraintToJSON,
} from './Constraint';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';
import type { TypeConstants } from './TypeConstants';
import {
    TypeConstantsFromJSON,
    TypeConstantsFromJSONTyped,
    TypeConstantsToJSON,
} from './TypeConstants';

/**
 * Info to further specify properties if the value is used as cell in a table grid
 * @export
 * @interface ValueInfo
 */
export interface ValueInfo {
    /**
     * 
     * @type {TypeConstants}
     * @memberof ValueInfo
     */
    type?: TypeConstants;
    /**
     * Tooltip
     * @type {string}
     * @memberof ValueInfo
     */
    title?: string;
    /**
     * #RRGGBB (hexadecimal) format
     * @type {string}
     * @memberof ValueInfo
     */
    backgroundColor?: string;
    /**
     * 
     * @type {IconRef}
     * @memberof ValueInfo
     */
    icon?: IconRef;
    /**
     * On edit, switch off editablity and make the value read-only, render as on show page
     * @type {boolean}
     * @memberof ValueInfo
     */
    useShowView?: boolean;
    /**
     * On edit, and if a selection is to be made, multiple selections shall be supported
     * @type {boolean}
     * @memberof ValueInfo
     */
    list?: boolean;
    /**
     * 
     * @type {Constraint}
     * @memberof ValueInfo
     */
    constraint?: Constraint;
    /**
     * On edit, switches between single-line text input (if false) and multi-line text input (if true)
     * @type {boolean}
     * @memberof ValueInfo
     */
    isMultiLine?: boolean;
}

/**
 * Check if a given object implements the ValueInfo interface.
 */
export function instanceOfValueInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ValueInfoFromJSON(json: any): ValueInfo {
    return ValueInfoFromJSONTyped(json, false);
}

export function ValueInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : TypeConstantsFromJSON(json['type']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'useShowView': !exists(json, 'useShowView') ? undefined : json['useShowView'],
        'list': !exists(json, 'list') ? undefined : json['list'],
        'constraint': !exists(json, 'constraint') ? undefined : ConstraintFromJSON(json['constraint']),
        'isMultiLine': !exists(json, 'isMultiLine') ? undefined : json['isMultiLine'],
    };
}

export function ValueInfoToJSON(value?: ValueInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TypeConstantsToJSON(value.type),
        'title': value.title,
        'backgroundColor': value.backgroundColor,
        'icon': IconRefToJSON(value.icon),
        'useShowView': value.useShowView,
        'list': value.list,
        'constraint': ConstraintToJSON(value.constraint),
        'isMultiLine': value.isMultiLine,
    };
}

